import { render, staticRenderFns } from "./EditProcedure.vue?vue&type=template&id=3d31ab70&"
import script from "./EditProcedure.vue?vue&type=script&lang=js&"
export * from "./EditProcedure.vue?vue&type=script&lang=js&"
import style0 from "./EditProcedure.vue?vue&type=style&index=0&id=3d31ab70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports